export default __webpack_public_path__ + "0f9f12668067d8c0282f12205fdfbc64.png";